<template>
    <Card class="max-w-xl">
        <CustomerForm
            :errors="errors"
            @submit="storeCustomer"
        />
    </Card>
</template>

<script>
import CustomerForm from '@/components/customers/CustomerForm.vue';
import resourceMixin from '@/mixins/resourceMixin';
export default {
    name: 'CustomerCreate',
    components: {
        CustomerForm,
    },
    mixins: [resourceMixin('customers')],
};
</script>

<style></style>
